import { UserService } from './Service';
import { useEffect, useState } from 'react';
import { useAppContext } from '../../../contexts/AppContext';
import { SettingsRow, SettingsSection } from '../estabelecimento/Form/SettingsGroup';

const service = new UserService();

export default function ConfiguracoesContaIdioma() {
    const { errorSnackbar, successSnackbar } = useAppContext();
    const [loading, setLoading] = useState(false);
    const [idioma, setIdioma] = useState('pt-BR');

    useEffect(() => {
        service
            .getSettings()
            .then(({ data }) => {
                if (data?.preferredLanguage) {
                    setIdioma(data.preferredLanguage);
                }
            })
            .catch(() => {
                errorSnackbar('Erro ao buscar configurações da conta.');
            })
    }, []);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        service
            .updateSettings({ preferredLanguage: idioma })
            .then(() => {
                successSnackbar('Idioma atualizado com sucesso!');
            })
            .catch(() => {
                errorSnackbar('Erro ao salvar configurações.');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setIdioma(e.target.value);
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid gap-6 xl:grid-cols-2 xl:items-start">
                <SettingsSection title="Preferência" footer="Fica registrado como o idioma preferido da sua conta.">
                    <SettingsRow label="Idioma" htmlFor="preferredLanguage">
                        <select
                            id="preferredLanguage"
                            className="select estab-field"
                            name="preferredLanguage"
                            value={idioma}
                            onChange={handleChange}
                            disabled={loading}
                        >
                            <option value="pt-BR">Português (Brasil)</option>
                            <option value="en-US">Inglês (EUA)</option>
                            <option value="es-ES">Espanhol</option>
                        </select>
                    </SettingsRow>
                </SettingsSection>
            </div>

            <div className="estab-savebar mt-6">
                <button
                    className="btn btn-primary w-full sm:w-auto sm:min-w-[11rem]"
                    type="submit"
                    disabled={loading}
                >
                    {loading && <span className="loading loading-spinner loading-sm"></span>}
                    Salvar alterações
                </button>
            </div>
        </form>
    );
}
